import { render, staticRenderFns } from "./SocialEmployeeCard.vue?vue&type=template&id=f6ebcc7a&scoped=true&lang=html&"
import script from "./SocialEmployeeCard.vue?vue&type=script&lang=js&"
export * from "./SocialEmployeeCard.vue?vue&type=script&lang=js&"
import style0 from "./SocialEmployeeCard.vue?vue&type=style&index=0&id=f6ebcc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ebcc7a",
  null
  
)

export default component.exports